import React, { useRef } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import PreviewRow from "../../elements/preview-row";
import PrimaryLink from "../../elements/primary-link";
import Image from "../../elements/image";
import { generateReactKey } from "../../utils/reactKey";
import "./style.scss";

const CalculationToolSummary = ({ heading, features, includedFeatures, info, legal, cta }) => {
  const isBrowser = typeof window !== `undefined`,
    calculationToolSummaryRef = useRef(null);

  return (
    <section ref={calculationToolSummaryRef} className="calculation-tool-summary grid">
      {heading && (
        <div className="heading">
          <Heading {...heading} />
        </div>
      )}

      {(features || includedFeatures) && (
        <div className="features">
          {features.main && (
            <div className="main">
              <PreviewRow {...features.main} />
            </div>
          )}
          {features.items &&
            features.items.map(item => {
              if (item?.value || item?.label) {
                return <PreviewRow key={generateReactKey()} {...item} />;
              }
            })}

          {includedFeatures.main && (
            <div className="main">
              <PreviewRow {...includedFeatures.main} />
            </div>
          )}
          {includedFeatures.items &&
            includedFeatures.items.map(item => {
              if (item?.value || item?.label) {
                return <PreviewRow key={generateReactKey()} {...item} />;
              }
            })}
        </div>
      )}
      {(info || legal) && (
        <div className="info">
          <BodyText {...info} />
          {legal.image?.src && <Image {...legal.image} />}
          <BodyText {...legal} className="legal" />
        </div>
      )}
      {cta && (
        <div className="cta">
          <PrimaryLink
            {...{
              ...cta,
              colorScheme: cta.colorScheme || "green"
            }}
          />
        </div>
      )}
    </section>
  );
};

export default CalculationToolSummary;

CalculationToolSummary.propTypes = {
  heading: PropTypes.object,
  features: PropTypes.shape({
    main: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    }),
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.any
      })
    )
  }),
  includedFeatures: PropTypes.shape({
    main: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    }),
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      })
    )
  }),
  info: PropTypes.shape({ value: PropTypes.string }),
  legal: PropTypes.shape({ value: PropTypes.string }),
  cta: PropTypes.object,
  price: PropTypes.shape({
    overline: PropTypes.string,
    value: PropTypes.string,
    cta: PropTypes.object
  })
};
